export default {"src":"/_next/static/media/linea-explorer.0ffd269f.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};